/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Seo_Measured_Subject_PlatformInputs */

const en_seo_measured_subject_platform = /** @type {(inputs: Seo_Measured_Subject_PlatformInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}`)
};

const zh_hans1_seo_measured_subject_platform = /** @type {(inputs: Seo_Measured_Subject_PlatformInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}`)
};

const pt_br2_seo_measured_subject_platform = /** @type {(inputs: Seo_Measured_Subject_PlatformInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`à API para ${i?.name}`)
};

const es_seo_measured_subject_platform = /** @type {(inputs: Seo_Measured_Subject_PlatformInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`a la API de ${i?.name}`)
};

const fr_seo_measured_subject_platform = /** @type {(inputs: Seo_Measured_Subject_PlatformInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}`)
};

const de_seo_measured_subject_platform = /** @type {(inputs: Seo_Measured_Subject_PlatformInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}`)
};

const ru_seo_measured_subject_platform = /** @type {(inputs: Seo_Measured_Subject_PlatformInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}`)
};

const it_seo_measured_subject_platform = /** @type {(inputs: Seo_Measured_Subject_PlatformInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}`)
};

/**
* | output |
* | --- |
* | "{name}" |
*
* @param {Seo_Measured_Subject_PlatformInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_measured_subject_platform = /** @type {((inputs: Seo_Measured_Subject_PlatformInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Measured_Subject_PlatformInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_measured_subject_platform(inputs)
	if (locale === "pt-BR") return pt_br2_seo_measured_subject_platform(inputs)
	if (locale === "es") return es_seo_measured_subject_platform(inputs)
	if (locale === "fr") return fr_seo_measured_subject_platform(inputs)
	if (locale === "de") return de_seo_measured_subject_platform(inputs)
	if (locale === "ru") return ru_seo_measured_subject_platform(inputs)
	if (locale === "it") return it_seo_measured_subject_platform(inputs)
	return en_seo_measured_subject_platform(inputs)
});